import React from 'react'
import { useTranslation } from 'react-i18next'
import errorImg from '../assets/errorLoading.svg'
import CreateError from './CreateError'

export default function LoadingError() {
  const [t] = useTranslation()

  const errorInfo = {
    heading: t('centers.loading-error', 'We were unable to load this page'),
    image: errorImg,
    paragraph: t('centers.loading-error.fix', 'Try refreshing the page, or check back later.'),
  }

  return <CreateError errorInfo={errorInfo} />
}
